
export interface Issue {
  id: string;
  date: string;
  title: string;
  url: string;
  image?: string;
  content?: string;
}

export const issues: Issue[] = [
  {
    id: "ai-skills-54x-more-desirable",
    date: '2025-04-11',
    title: 'AI is making human skills 54x more desirable',
    url: 'https://pub.mailmodo.site/p/x9LLgnnbc8',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_1200:879,c_crop/v1744373547/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/37e944f5ab2a61a731c976354038ea95_txfbwj.png'
  },
  {
    id: "salary-divide-in-recruitment",
    date: '2025-04-04',
    title: 'The salary divide in recruitment is getting deeper',
    url: 'https://pub.mailmodo.site/p/XcgctjZlnS',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_636:360,c_crop/v1743771156/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/eb83a9cf4810369f5b1c42509a91b848_ttw2cc.png'
  },
  {
    id: "fixed-salary-bands-failing",
    date: '2025-03-28',
    title: 'Why fixed salary bands are failing and what\'s the future',
    url: 'https://pub.mailmodo.site/p/g8Xf5PNdVL',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_725:545,c_crop/v1743142684/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/549f50c0449749138a25b1ba96cd4b42_rdv6ip.png'
  },
  {
    id: "ai-impact-on-job-satisfaction",
    date: '2025-03-07',
    title: 'The interesting case of AI\'s impact on job satisfaction',
    url: 'https://pub.mailmodo.site/p/FVhqMVMqj6',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_2502:1138,c_crop/v1741352159/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/88526697268784ef3df859a0aa5e45fd_euxtaq.png'
  },
  {
    id: "michael-page-2025-salary-report",
    date: '2025-02-28',
    title: '3 hidden trends in the Michael Page 2025 salary report',
    url: 'https://pub.mailmodo.site/p/1aCMubnpAk',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_742:1022,c_crop/v1740742213/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/62160cf8d56d890e39e1a7d3152df5f3_qyef59.png'
  },
  {
    id: "soft-skills-recruiters-need",
    date: '2025-02-14',
    title: '10 soft skills that recruiters need to ace to beat AI',
    url: 'https://pub.mailmodo.site/p/nzLYymLBE9',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_1920:1080,c_crop/v1739523298/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/410541eda823d984beb070ffeda3c45b_bfmigz.png'
  },
  {
    id: "wingify-200m-exit-lessons",
    date: '2025-01-24',
    title: 'What founders and recruiters can learn from Wingify\'s $200M exit',
    url: 'https://pub.mailmodo.site/p/VWJDk34Jnq',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_1940:980,c_crop/v1737698376/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/8b50ba06d8f28e76f6fe52f98ecbf7d3_hreesi.jpg'
  }
];


